import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import DrawerList from "./drawer-list/DrawerList";
import React, {useState} from "react";
import PropTypes from "prop-types";
import {useSidebarStyles} from "./SidebarStyles";
import {theme} from "../../../shared/theme";
import ContactBox from "./contact-box/ContactBox";
import ContattaciDialog from "./contattaci-dialog/ContattaciDialog";
import {useSelector} from "react-redux";
import {ListItem} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";

const Sidebar = (props) => {
    const classes = useSidebarStyles();
    const container = props.window !== undefined ? () => window.document.body : undefined;
    const [openContattaciDialog, setOpenContattaciDialog] = useState(false);

    const cookiePolicyUrl = useSelector((state) => state.authReducer.frontendConfiguration.cookiePolicy)
    const privacyPolicyUrl = useSelector((state) => state.authReducer.frontendConfiguration.privacyPolicy)

    const handleOpenNewTab = (url) => {
        const newTab = window.open(url, '_blank', 'noopener,noreferrer');
        if (newTab) newTab.opener = null
    };

    const policyURLS = (
        <>
            <ListItem button
                      onClick={() => handleOpenNewTab(privacyPolicyUrl)}>
                <Typography variant={"caption"} style={{color: "white"}}>
                    Privacy policy
                </Typography>
            </ListItem>
            <ListItem button
                      onClick={() => handleOpenNewTab(cookiePolicyUrl)}>
                <Typography variant={"caption"} style={{color: "white"}}>
                    Cookie policy
                </Typography>
            </ListItem>
        </>
    )

    return (
        <nav className={classes.drawer} aria-label="mailbox folders">
            <Hidden smUp implementation="css">
                <Drawer
                    id="drawer-paper"
                    container={container}
                    variant="temporary"
                    anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                    open={props.sidebarOpen}
                    onClose={props.handleSidebarToggle}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                >
                    <DrawerList/>
                    <ContactBox setOpenContattaciDialog={setOpenContattaciDialog}/>
                    {policyURLS}
                </Drawer>

            </Hidden>
            <Hidden xsDown implementation="css">
                <Drawer
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    variant="permanent"
                    open>
                    <DrawerList/>
                    <ContactBox setOpenContattaciDialog={setOpenContattaciDialog}/>
                    {policyURLS}
                </Drawer>
            </Hidden>
            {openContattaciDialog ? (
                <ContattaciDialog
                    open={openContattaciDialog}
                    handleDialogClose={() => setOpenContattaciDialog(false)}
                    handleContattaciCloseButton={() => setOpenContattaciDialog(false)}
                />
            ) : null}
        </nav>
    )
}

Sidebar.propTypes = {
    sidebarOpen: PropTypes.bool.isRequired,
    handleSidebarToggle: PropTypes.func.isRequired
}
export default Sidebar;
